import { Loadable } from '@/components/loaders';
import { BaseModal } from '@/lib/Modals';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

type SourceConnectorDisconnectModalProps = {
  connectorName: string;
  isDisconnecting: boolean;
  errorMessage?: string | null;
  onConfirm: (force: boolean) => void;
  onClose: () => void;
};

export const SourceConnectorDisconnectModal: FC<SourceConnectorDisconnectModalProps> = ({
  connectorName,
  isDisconnecting,
  errorMessage,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation('data_sources');
  const [forceDelete, setForceDelete] = useState(false);

  return (
    <BaseModal
      onClose={onClose}
      classNames={{
        dialog: 'max-w-md w-full',
        content: 'min-h-0 p-0',
      }}
    >
      <div className='p-6'>
        <h2 className='mb-4 text-xl font-semibold'>{t('source_connectors.disconnect_confirm_title', { connectorName })}</h2>

        <p className='mb-4 text-sm text-secondary-600'>{t('source_connectors.disconnect_confirm_body')}</p>

        <div className='mb-4'>
          <label className='flex items-center'>
            <input type='checkbox' checked={forceDelete} onChange={(e) => setForceDelete(e.target.checked)} className='mr-2' />
            <span className='text-sm text-secondary-700'>{t('source_connectors.force_disconnect_label')}</span>
          </label>
        </div>

{errorMessage && (
  <p role='alert' className='mb-4 text-sm text-red-600'>
    {errorMessage}
  </p>
)}

        <div className='flex justify-end gap-3'>
          <button type='button' onClick={onClose} className='rounded border border-gray-300 px-4 py-2 text-sm font-medium hover:bg-gray-50'>
            {t('source_connectors.disconnect_cancel')}
          </button>
          <Loadable isLoading={isDisconnecting}>
            <button
              type='button'
              onClick={() => onConfirm(forceDelete)}
              className='rounded bg-red-600 px-4 py-2 text-sm font-medium text-white-100 hover:bg-red-700'
            >
              {t('source_connectors.disconnect')}
            </button>
          </Loadable>
        </div>
      </div>
    </BaseModal>
  );
};
